/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Pdf_Page4_CommentsInputs */



/**
* | output |
* | --- |
* | "Intervention comments" |
*
* @param {Intervention_Plan_Pdf_Page4_CommentsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_pdf_page4_comments = /** @type {((inputs?: Intervention_Plan_Pdf_Page4_CommentsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Pdf_Page4_CommentsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Intervention comments")
	return /** @type {LocalizedString} */ ("Commentaires sur l'intervention")
});